module.exports = __webpack_public_path__ + "static/media/TWL-LandingPage-Social-Image.bf411d4c.jpg";